import Loadable from 'components/Loadable';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const Index = Loadable(lazy(() => import('./index')));

export const routes: RouteObject[] = [
    {
        path: '/laporan/pembukaan-rekening',
        element: <Index />,
    }
];
